module.exports = __webpack_public_path__ + "img/hero_image_drugs.a1758f4.jpg";